export default () => {
  Array.from(document.querySelectorAll('select:not(.estate-picker)')).forEach((select) => {
      select.addEventListener('change', () => {
         // console.log("change: select");
      const value = select.previousElementSibling;
      const options = select.children;
      if (options && options.length >= (select.selectedIndex + 1)) {
        value.textContent = options[select.selectedIndex].textContent;
      }
    });
  });
};
